import { CampaignWithCalleeFields_calleeFields } from "src/graphql/generated/CampaignWithCalleeFields";
import { getCampaign_campaign_questions } from "src/graphql/generated/getCampaign";
import { CalleeField } from "src/graphql/generated/globalTypes";

const MANDATORY_BUILTIN_FIELDS = new Set([CalleeField.FIRST_NAME]);

export function questionsContainField(
  questions: getCampaign_campaign_questions[],
  calleeField: CampaignWithCalleeFields_calleeFields
): boolean {
  return Object.values(questions).some(question => {
    const calleeFieldRegex = question.isRichText
      ? `"calleeFieldId":"${calleeField.id}"`
      : `{callee_field:${calleeField.id}}`;
    return (
      question.script?.match(calleeFieldRegex) ||
      question.sendMessageSettings?.text.match(calleeFieldRegex)
    );
  });
}

export function fieldIsAlwaysRequired(
  calleeField: CampaignWithCalleeFields_calleeFields
): boolean {
  return (
    calleeField.builtInField != null &&
    MANDATORY_BUILTIN_FIELDS.has(calleeField.builtInField)
  );
}
